import { Modal } from 'antd';
import UpdateBookingForm from '../Booking/UpdateBookingForm';

const UpdateBookingModal = ({ isOpen, onClose, bookingId, booking }) => (
  <Modal
    title="Make an Appointment"
    open={isOpen}
    onCancel={onClose}
    width={1000}
    footer={null}
    destroyOnHidden
  >
    <UpdateBookingForm bookingId={bookingId} onClose={onClose} booking={booking} />
  </Modal>
);

export default UpdateBookingModal;